import { Center, Loader } from '@mantine/core'

export function RoutePending() {
  return (
    <Center mih={240}>
      <Loader />
    </Center>
  )
}
